export default __webpack_public_path__ + "images/10093b0e23d9b86eaaaeebe4a161886d.svg";